var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "new-game-sidebar" }, [
    _c("div", { staticClass: "new-game-sidebar__bet-creator" }, [
      _vm._m(0),
      _c("div", { staticClass: "bet-creator" }, [
        _c("div", { staticClass: "bet-creator__content" }, [
          _c("div", { staticClass: "crash-home-bet-creator-ratios" }, [
            _c(
              "form",
              {
                staticClass: "bet-creator__ratios ratios",
                attrs: { novalidate: "" },
              },
              [
                _c("div", { staticClass: "ratios__form ratios-form" }, [
                  _c("div", { staticClass: "header-bar" }, [
                    _c(
                      "label",
                      {
                        staticClass: "ratios-form__label",
                        attrs: { for: "ratio" },
                      },
                      [_vm._v("自动收取倍数")]
                    ),
                    _vm.isCheckCashout
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn ratios__preset-button ratios__preset-button_settings",
                            attrs: { type: "button" },
                            on: { click: _vm.isCloseCheckCashout },
                          },
                          [_c("i", { staticClass: "icon icon_check-alt" })]
                        )
                      : _c(
                          "button",
                          {
                            staticClass:
                              "btn ratios__preset-button ratios__preset-button_settings",
                            attrs: { type: "button" },
                            on: { click: _vm.isShowCheckCashout },
                          },
                          [_c("i", { staticClass: "icon icon_gear-bold" })]
                        ),
                  ]),
                  _c("div", { staticClass: "ratios-form__wrapper" }, [
                    _c("div", { staticClass: "ratios-form__input-wrapper" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.autoCashout,
                            expression: "autoCashout",
                          },
                        ],
                        staticClass: "ratios-form__input",
                        attrs: {
                          type: "number",
                          placeholder: "Enter",
                          autocomplete: "off",
                          id: "ratio",
                          formcontrolname: "ratio",
                        },
                        domProps: { value: _vm.autoCashout },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.autoCashout = $event.target.value
                            },
                            _vm.changeAutoCashout,
                          ],
                        },
                      }),
                    ]),
                    _vm.isCheckCashout
                      ? _c(
                          "div",
                          { staticClass: "ratios__presets" },
                          [
                            _vm._l(
                              _vm.enterAutoCashout,
                              function (cashout, index) {
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.enterAutoCashout[index],
                                        expression: "enterAutoCashout[index]",
                                      },
                                    ],
                                    key: cashout,
                                    staticClass: "ratios__preset-input",
                                    attrs: {
                                      type: "number",
                                      autocomplete: "off",
                                    },
                                    domProps: {
                                      value: _vm.enterAutoCashout[index],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.enterAutoCashout,
                                          index,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              }
                            ),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          { staticClass: "ratios__presets" },
                          _vm._l(_vm.enterAutoCashout, function (cashout) {
                            return _c(
                              "button",
                              {
                                key: cashout,
                                staticClass: "btn ratios__preset-button",
                                class: {
                                  "is-active": cashout == _vm.autoCashout,
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setAutoCashout(cashout)
                                  },
                                },
                              },
                              [_vm._v(" x" + _vm._s(cashout))]
                            )
                          }),
                          0
                        ),
                  ]),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "bets-manual-bet" }, [
            _c(
              "label",
              {
                staticClass: "bet-form__label",
                attrs: { "data-v-0a843e50": "", for: "bet-amount" },
              },
              [_vm._v("输入游戏额度")]
            ),
            _c("div", { staticClass: "manual-bet manual-bet_crash" }, [
              _c("div", { staticClass: "manual-bet__form bet-form" }, [
                _c("div", { staticClass: "bet-form__wrapper" }, [
                  _c(
                    "span",
                    {
                      staticClass: "bet-form__currency currency_USD",
                      class: { "bet-form__currency--icon": _vm.currencyIcon },
                      attrs: { currencyclassname: "" },
                    },
                    [
                      _vm.currencyIcon
                        ? _c("img", {
                            staticClass: "bet-form__currency-icon",
                            attrs: { src: _vm.currencyIcon, alt: "" },
                          })
                        : _vm._e(),
                    ]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.betAmount,
                        expression: "betAmount",
                      },
                    ],
                    staticClass: "bet-form__input",
                    attrs: {
                      type: "number",
                      id: "bet-amount",
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.betAmount },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.betAmount = $event.target.value
                        },
                        function ($event) {
                          return _vm.limitDecimalPlace(2, $event)
                        },
                      ],
                    },
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "bet-form__action btn",
                      attrs: { type: "button" },
                      on: { click: _vm.setMinusBetAmount },
                    },
                    [_c("img", { attrs: { src: _vm.device } })]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "bet-form__action btn",
                      attrs: { type: "button" },
                      on: { click: _vm.setAddBetAmount },
                    },
                    [_c("img", { attrs: { src: _vm.asterisk } })]
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "manual-bet__actions" },
                [
                  _vm._l(_vm.enterAmount, function (amount) {
                    return _c(
                      "button",
                      {
                        key: amount,
                        staticClass: "manual-bet__action btn",
                        class: { "is-active": _vm.betAmount == amount },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.setBetAmount(amount)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "currency_USD" }, [
                          _vm._v(_vm._s(amount)),
                        ]),
                      ]
                    )
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "manual-bet__action btn",
                      class: { "is-active": _vm.betAmount == _vm.allBalance },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.setBetAmountMax()
                        },
                      },
                    },
                    [_vm._v(" MAX ")]
                  ),
                ],
                2
              ),
            ]),
          ]),
          _c("div", { staticClass: "bet-creator__wrapper" }, [
            _c("div", { staticClass: "crash-home-bet-creator" }, [
              _vm.isJoined
                ? _c(
                    "button",
                    {
                      staticClass: "bet-creator__action btn btn_start",
                      attrs: { type: "button", disabled: _vm.isBtnDisable },
                      on: {
                        click: function ($event) {
                          return _vm.clickCashout()
                        },
                      },
                    },
                    [
                      _vm.gameState.status == _vm.GAME_STATES.Starting ||
                      _vm.gameState.status == _vm.GAME_STATES.NotStarted
                        ? [
                            _c("span", { staticClass: "btn__text" }, [
                              _vm._v("已参与"),
                            ]),
                          ]
                        : _vm._e(),
                      _vm.gameState.status == _vm.GAME_STATES.InProgress &&
                      !_vm.ownBet.winningAmount
                        ? [
                            _c("span", { staticClass: "btn__text" }, [
                              _vm._v("收取"),
                            ]),
                            _c("span", { staticClass: "currency_USDd" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.ownBet &&
                                      (_vm.ownBet.betAmount * _vm.tick).toFixed(
                                        2
                                      )
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        : _vm._e(),
                      _vm.gameState.status == _vm.GAME_STATES.Over ||
                      _vm.gameState.status == _vm.GAME_STATES.Crash ||
                      _vm.ownBet.winningAmount
                        ? [
                            _c("span", { staticClass: "btn__text" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.ownBet.winningAmount
                                      ? "你赢了"
                                      : "你输了"
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _c(
                    "button",
                    {
                      staticClass: "bet-creator__action btn btn_start",
                      attrs: { type: "button", disabled: _vm.isBtnDisable },
                      on: {
                        click: function ($event) {
                          return _vm.clickBet()
                        },
                      },
                    },
                    [
                      _vm.gameState.status == _vm.GAME_STATES.InProgress
                        ? _c("span", { staticClass: "btn__text" }, [
                            _vm._v(" 进行中... "),
                          ])
                        : _vm.gameState.status == _vm.GAME_STATES.Over ||
                          _vm.gameState.status == _vm.GAME_STATES.Crash
                        ? _c("span", { staticClass: "btn__text" }, [
                            _vm._v("结算中..."),
                          ])
                        : _c("span", { staticClass: "btn__text" }, [
                            _vm._v(" 立即加入 "),
                          ]),
                    ]
                  ),
            ]),
            _c(
              "div",
              {
                staticClass: "bets-autobet-button",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.autoBet ? _vm.setAutoBet(0) : _vm.toggleOpenDropdown()
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "autobet-btn autobet-btn_crash btn btn_column",
                    attrs: {
                      type: "button",
                      disabled:
                        _vm.gameState.status == _vm.GAME_STATES.InProgress,
                    },
                  },
                  [
                    _c("img", { attrs: { src: _vm.auto } }),
                    _c("div", { staticClass: "btn__text" }, [
                      _vm._v(_vm._s(_vm.autoBet ? "stop" : "auto")),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "dropdown__list",
                    class: { "is-open": _vm.isOpenDropdown },
                    attrs: { dropdowncontent: "" },
                  },
                  _vm._l(_vm.dropdownList, function (item) {
                    return _c(
                      "div",
                      {
                        key: item,
                        staticClass: "dropdown__item",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.setAutoBet(item)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "dropdown__title" }, [
                          _vm._v(" " + _vm._s(item) + " "),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "new-game-sidebar__footer" }, [
      _c("div", {
        staticClass: "new-game-sidebar__shield icon icon_shield-bold",
      }),
      _c("div", { staticClass: "new-game-sidebar__round" }, [
        _c("div", { staticClass: "new-game-sidebar__round-title" }, [
          _vm._v("防作弊哈希号"),
        ]),
        _c("div", { staticClass: "new-game-sidebar__round-number" }, [
          _vm._v(
            " #" +
              _vm._s(_vm.publicSeed && _vm.publicSeed.substring(0, 10)) +
              " "
          ),
        ]),
      ]),
      _c("div", { staticClass: "new-game-sidebar__hash" }, [
        _vm._v(
          " " +
            _vm._s(_vm.privateHash && _vm.truncateString(_vm.privateHash, 10)) +
            " "
        ),
        _c(
          "button",
          {
            staticClass: "btn btn_icon button_copy",
            on: { click: _vm.copyText },
          },
          [_c("span", { staticClass: "icon icon_copy-bold-alt" })]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "new-game-sidebar__head" }, [
      _c("div", { staticClass: "new-game-sidebar__title" }, [
        _vm._v(" Crash "),
      ]),
      _c("span", {
        staticClass: "new-game-sidebar__info icon icon_info-instruction",
        staticStyle: { cursor: "not-allowed" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }